import React from 'react';
import '../../../styles/common/Ticker/Ticker.css'

function Ticker({ title, content, left, logo, chainLogo }){
  return(
    <div className={ left ? 'ticker-container ticker-container-logo ticker-left' : 'ticker-container ticker-container-logo ticker-right'}>
      <div className='ticker-content ticker-content-logo'>
        <div className='ticker-tab'>
          { title ? <h6 className='ticker-tit no-margin'>{ title }</h6> : null }
          { logo ? <div className='ticker-logo-container' style={{ position: 'relative', width: '120px' }}>
            <img style={{ width: '78px' }} src={logo} alt={title} />
            { chainLogo ? <img style={{
              width: '40px',
              position: 'absolute',
              top: '40px',
              left: '80px',
            }} src={chainLogo} alt={title} /> : null }
          </div> : null }
          <h5 className='tick-cont no-margin'>{ content }</h5>
        </div>
      </div>
    </div>
  )
}

export default Ticker;